import achievementBg from './achievements/achievement-bg.png';

import logo from './icons/logo.svg';
import signet from './icons/signet.svg';
import activerse from './icons/activerse_logo_horizontal.svg';
import backIcon from './icons/back.svg';

import eye from './icons/eye-solid.svg';
import eyeSlash from './icons/eye-slash-solid.svg';

import unauthorized from './other-pages/unauthorized.png';

import favouriteFull from './dayplan/favourite_full.png';
import favouriteEmpty from './dayplan/favourite_empty.png';

import cookbookFavouriteFull from './cookbook-master/fav_on.png';
import cookbookFavouriteEmpty from './cookbook-master/fav_off.png';

import favouriteFullSmall from './cookbook/fav_small_on.png';
import favouriteEmptySmall from './cookbook/fav_small_off.png';
import favouritesIcon from './cookbook/favourites-icon.svg';
import searchIcon from './cookbook/input_icon_search.svg';
import favMealsIcon from './title-bar/fav-meals.svg';
import cookbookFavMealsIcon from './title-bar/cookbook-fav-meals.svg';

import playBtn from './dayplan/play-button.svg';

import instacartLogo from './icons/instacart.svg';

import minus from './cookbook/minus.svg';
import minusMulti from './cookbook/minus_multi.svg';
import plus from './cookbook/plus.svg';
import plusMulti from './cookbook/plus_multi.svg';
import star from './cookbook/star.svg';

import iconChange from './cookbook/change.svg';
import iconChangeDone from './cookbook/change_active.svg';
import iconChangeActive from './cookbook/change_replace.svg';

import glass from './hydration/glass.svg';
import bottle from './hydration/bottle.svg';
import custom from './hydration/custom.svg';

import hydrationSuccessIcon from './hydration/hydration_goal_achieved.svg';
import hydrationSuccessIconLarge from './hydration/hydration_goal_achieved_large.svg';

import error404Img from './errors/error_404.png';
import genericErrorImg from './errors/error_unknown.png';
import networkErrorImg from './errors/error_network.png';
import noAccountErrorImg from './errors/login_fail_social.png';
import envelope from './remove-account/envelope.svg';
import removeAccountSuccess from './remove-account/success.svg';
import removeAccountAlert from './remove-account/alert.svg';
import removeAccountError from './remove-account/error.svg';
import doneIcon from './remove-account/doneIcon.svg';

import settingsIcon from './icons/settings.svg';

import appStore from './icons/app_store_badge.svg';
import googlePlay from './icons/google_play_badge.svg';

import imagePlaceholder from './image-placeholder.jpeg';
import thankYouPageBg from './thankyou/thank-you-page-main-img@2x.png';
import thankYouPageBgMobile from './thankyou/thank-you-page-main-img-mobile@2x.png';
import thankYouPageAppEn from './thankyou/app-features-img@2x.png';
import thankYouPageLogInEn from './thankyou/logInImg@2x.png';

import confirm from './thankyou/activation-page-img@2x.png';

import infoIcon from './icons/info.svg';
import shoppingListIcon from './title-bar/shopping-list.svg';
import doneKcal from './dayplan/done-kcal.svg';

import changeButton from './dayplan/change_button.svg';
import eatenButton from './dayplan/eaten_button.svg';
import eatenButtonFull from './dayplan/eaten_button_full.svg';
import tomorrowAlertIcon from './dayplan/tomorrow_alert.svg';

import copyForTomorrow from './dayplan/meal.doneButtonIcon.svg';

import bulb from './dayplan/bulb.svg';
import iconChangeDone2 from './dayplan/change_active.svg';
import iconChangeActive2 from './dayplan/change_replace.svg';

import gearIcon from './dayplan/gear.svg';
import changeMealIcon from './dayplan/change_meal.svg';
import favIcon from './dayplan/fav_icon.svg';
import noSearchResultsIcon from './dayplan/no_search_results_icon.svg';
import addToMealplan from './dayplan/add_to_mealplan.svg';

import fastingStatusFasting from './if/fasting-status-fasting.svg';
import fastingStatusEating from './if/fasting-status-eating.svg';

import weightNeeded from './dayplan/measurementImg.png';
import goalLost from './dayplan/goalLostImg.png';
import goalReached from './dayplan/goalAchievedImg.png';
import noDietEn from './dayplan/noDietImg.jpg';
import dietInFuture from './dayplan/dietAvailableSoonImg.png';
import pendingPayment from './dayplan/paymentPendingImg.png';

import favouritesIcon2 from './dayplan/favourites-icon.svg';
import mealPlanPrice from './dayplan/diet_price.svg';

import ratingStarEmpty from './dayplan/info.ratingStarEmpty.svg';
import ratingStarHalf from './dayplan/info.ratingStarHalf.svg';
import ratingStarFull from './dayplan/info.ratingStarFull.svg';

import ratingStarPopupEmpty from './dayplan/popup.ratingStarEmpty.svg';
import ratingStarPopupFull from './dayplan/popup.ratingStarFull.svg';

import ratingButtonEmpty from './dayplan/button.ratingStar.empty.svg';
import ratingButtonFull from './dayplan/button.ratingStar.full.svg';

import buttonChange from './dayplan/button.change.svg';

import DownArrow from './icons/chevron-down.svg?react';
import LeftArrow from './icons/chevron-left.svg?react';
import RightArrow from './icons/chevron-right.svg?react';

import noDietImg from './shopping-list/no_shoppin_list_img.png';
import handdrawnIcon from './shopping-list/handdrawn_icon.svg';

// navbar
import chevron from './navbar/chevron.svg';
import close from './navbar/close.svg';
import hamburger from './navbar/hamburger.svg';
import login from './navbar/login.svg';

const images = {
  achievementBg,
  logo,
  activerse,
  backIcon,
  eye,
  eyeSlash,
  unauthorized,
  favouriteFull,
  favouriteEmpty,
  favouriteFullSmall,
  favouriteEmptySmall,
  favouritesIcon,
  searchIcon,
  favMealsIcon,
  playBtn,
  instacartLogo,
  minus,
  minusMulti,
  plus,
  plusMulti,
  star,
  iconChange,
  iconChangeDone,
  iconChangeActive,
  glass,
  bottle,
  custom,
  hydrationSuccessIcon,
  hydrationSuccessIconLarge,
  error404Img,
  genericErrorImg,
  networkErrorImg,
  noAccountErrorImg,
  envelope,
  removeAccountSuccess,
  removeAccountAlert,
  removeAccountError,
  settingsIcon,
  appStore,
  googlePlay,
  imagePlaceholder,
  thankYouPageBg,
  thankYouPageBgMobile,
  thankYouPageAppEn,
  thankYouPageLogInEn,
  confirm,
  infoIcon,
  shoppingListIcon,
  doneKcal,
  fastingStatusFasting,
  fastingStatusEating,
  changeButton,
  eatenButton,
  eatenButtonFull,
  tomorrowAlertIcon,
  noDietImg,
  handdrawnIcon,
  bulb,
  iconChangeDone2,
  iconChangeActive2,
  weightNeeded,
  goalLost,
  goalReached,
  noDietEn,
  dietInFuture,
  pendingPayment,
  changeMealIcon,
  favIcon,
  noSearchResultsIcon,
  addToMealplan,
  favouritesIcon2,
  mealPlanPrice,
  ratingStarEmpty,
  ratingStarHalf,
  ratingStarFull,
  ratingButtonEmpty,
  ratingButtonFull,
  ratingStarPopupEmpty,
  ratingStarPopupFull,
  buttonChange,
  copyForTomorrow,
  gearIcon,
  cookbookFavouriteFull,
  cookbookFavouriteEmpty,
  cookbookFavMealsIcon,
  doneIcon,
  chevron,
  hamburger,
  close,
  login,
  signet,
};

export const svgInline = {
  DownArrow,
  LeftArrow,
  RightArrow,
};

export default images;
